import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/connect`;

// Small, focused HTTP wrapper for the Stripe Connect coach-payout onboarding.
// Note: coach product/storefront endpoints were retired — Coachly now only
// sells single per-session bookings via /api/bookings/*.
export const connectApi = {
  listAccounts: () => axios.get(`${BASE}/accounts`).then((r) => r.data),
  createAccount: (payload) => axios.post(`${BASE}/accounts`, payload).then((r) => r.data),
  onboardingLink: (account_id) => axios.post(`${BASE}/onboarding-link`, { account_id }).then((r) => r.data),
  accountStatus: (account_id) => axios.get(`${BASE}/accounts/${account_id}/status`).then((r) => r.data),
};

export const CONNECT_TESTIDS = {
  page: "connect-page",
  coachSelect: "connect-coach-select",
  displayName: "connect-display-name",
  contactEmail: "connect-contact-email",
  createBtn: "connect-create-account-btn",
  accountId: "connect-account-id",
  onboardBtn: "connect-onboard-btn",
  refreshStatusBtn: "connect-refresh-status-btn",
  statusBlock: "connect-status-block",
  readyBadge: "connect-ready-badge",
  errorMsg: "connect-error",
  successMsg: "connect-success",
};
